export class DynamicImageRule {
  id;
  clientId;
  templateId;
  dayOfWeek;
  periodStart;
  periodEnd;
  deviceType;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/dynamic-images/dynamic-image-rule.model.ts